import { put } from "redux-saga/effects";
import axios from "../../axios-local-api";
import * as actions from "../actions";

export function* initStaticIPConfigSaga() {
  try {
    const response = yield axios.get("/staticIPConfig");
    if (response?.status === 200) {
      yield put(actions.setStaticIPConfig(response?.data));
    } else {
      yield put(actions.fetchStaticIPConfigFailed());
    }
  } catch (error) {
    yield put(actions.fetchStaticIPConfigFailed());
  }
}
